const ArrowIcon = ({ icons = [], isExpanded = false, size = "24", color = "currentColor", variant = "Linear", handleClick = null, cursor }) => {
    if (!Array.isArray(icons) || icons.length !== 2) {
        console.warn("ArrowIcon expects an array of exactly 2 icon components");
        return null;
    }

    const [CollapsedIcon, ExpandedIcon] = icons;
    const IconToRender = isExpanded ? ExpandedIcon : CollapsedIcon;

    return <IconToRender size={size} color={color} variant={variant} onClick={handleClick} cursor={cursor} />;
};
export default ArrowIcon;
